<template>

  <b-row align-h="center" class="d-flex flex-column flex-grow-1 py-3" style="height: 100%">

    <!-- <b-col v-if="generateWaiver == '1' && onlineWaiver == '0' ">
      <p> Click the button below to sign Gamebay Waiver </p>
      <b-button @click="clickedGamebay()" variant="info" style="color:white;margin-bottom:7%;">Gamebay Waiver</b-button>
    </b-col> -->

    <b-col class="text-center">
      <ConfirmPerson v-if="showConfirm"></ConfirmPerson>
      <router-view v-else></router-view>
    </b-col>

  </b-row>
</template>

<script>
import { mapState } from 'vuex';
import { SELECTED_RESERVATION } from '@/store/state';
import { FETCH_BOOKER, FETCH_RESERVATION, FETCH_WAIVER_COPY } from '@/store/actions';
import { formatTime, getDisplayName, validateTimestamp } from '@/utils';
import ReservationSelect from '@/components/ReservationSelect';
import BookerSelect from '@/components/BookerSelect';
import NavigationFooter from '@/components/NavigationFooter.vue';
import ConfirmPerson from '@/components/ConfirmPerson.vue';
// import Gamebay from '@/views/Gamebay.vue';

import axios from 'axios';
import { validateBeforeRouteLeave } from '@/utils/mixins/validateBeforeRouteLeave';

export default {

  data(){
      return{
        generateWaiver: '0',
        onlineWaiver: '',
    }
  },
  components: {
    ReservationSelect,
    BookerSelect,
    NavigationFooter,
    ConfirmPerson,
    // Gamebay,
    // generateWaiver: '',
  },
  computed: {
    ...mapState([
      SELECTED_RESERVATION
    ]),
  },
  data() {
    return {
      showConfirm: false,
    }
  },
  async created () {
    // Parse query params from hash fragment (for URLs like #/id?waiver=pgcps)
    let waiverType = 'standard';
    const hash = window.location.hash;
    if (hash.includes('?')) {
      const queryString = hash.split('?')[1];
      const params = new URLSearchParams(queryString);
      waiverType = params.get('waiver') || 'standard';
    }
    
    // Try to fetch the requested waiver type, fall back to standard if it fails
    const result = await this.$store.dispatch(FETCH_WAIVER_COPY, waiverType);
    if (!result && waiverType !== 'standard') {
      console.log(`Waiver type "${waiverType}" not found, falling back to standard`);
      await this.$store.dispatch(FETCH_WAIVER_COPY, 'standard');
    }

    var reservationId = this.$route.fullPath.slice(3);
    console.log(`full path is ${this.$route.fullPath}`);
    console.log('reservation id print '+reservationId);

    if(reservationId == 'atlgamebaywaiver'){
      console.log('load /gamebay waiver');
      return this.$router.push('/gamebay');
    }

    this.onlineWaiver = process.env.VUE_APP_ONLINE_WAIVER;

    if(process.env.VUE_APP_ONLINE_WAIVER == 1){
      this.generateWaiver = '1';
    }

    if (reservationId) {
      const reservation = await this.$store.dispatch(FETCH_RESERVATION, {id: reservationId});
      if (reservation) {
        if (reservation.reservation_cancelled) {
          console.log('reservation was cancelled, redirecting to bad link thing');
          // this.$router.replace({ name: 'FindReservation' })
          this.$router.push('/cancelled');
          return;
        }

        //if reservation.reservation_for is more than 2 days ago, redirect to old reservation page
        const dayDiff = (Date.now() - new Date(reservation.reservation_for).getTime()) / (1000 * 3600 * 24);
        if (!reservation.test && dayDiff > 2) {
          console.log("reservation is more than 2 days old, redirecting to old reservation page");
          this.$router.push('/old-reservation');
          return;
        }

        try {
          const booker = await this.$store.dispatch(FETCH_BOOKER, { id: reservation?.booker_id })
          console.log("found booker, redirecting to confirm");
          // if (booker) this.$router.push({ name: 'Confirm' })
          if (booker) this.showConfirm = true;
        } catch (err) {
          console.log("no booker");
          console.error(err)
        }
      }
      else{

        if(process.env.VUE_APP_ONLINE_WAIVER == 1){
          
          // maybe it's a hashed timestamp?
          try{
            console.log("yeah so I think I'mma try validating this as a timestamp");
            const auth = await axios.get(process.env.VUE_APP_TIMESTAMP_VALIDATOR + '/' + reservationId);
            this.$router.push('/find');
          }
          catch(err){
            console.log("not a timestamp, aw");
            console.warn(err);
            this.$router.replace({ name: 'FindReservation' })
            this.$router.push('/link');
          }

        }

      }
    }
    else { 
      // no reservation in id  
      if(process.env.VUE_APP_ONLINE_WAIVER == 1){
          this.$router.push('/link');
        }
        else{
      this.$router.push('/find');
        }
    }
    console.log(process.env.VUE_APP_SURVEY_BLACKLIST)
    console.log(process.env.VUE_APP_SURVEY_CUSTOM_SORT)
  },
  methods: {
    getDisplayName, // make accesible to template
    formatTime,
  },
  computed:{
  },

  mounted: function(){
  },

}
</script>

<style scoped>

</style>

